import { render, staticRenderFns } from "./selectquotation.vue?vue&type=template&id=e4a860c4&scoped=true&"
import script from "./selectquotation.vue?vue&type=script&lang=js&"
export * from "./selectquotation.vue?vue&type=script&lang=js&"
import style0 from "./selectquotation.vue?vue&type=style&index=0&id=e4a860c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a860c4",
  null
  
)

export default component.exports